export const updatebook = (id)=>{
    return{
        type: 'update/edit',
        payload: id,
    }
}
export const afterUpdate = ()=>{
    return{
        type: 'update/afteredit',        
    }
}
const initialState = [];

export const reducer = (state = initialState, action)=>{
    if(action.type === 'update/edit'){  
        return {id: action.payload};
    }else if(action.type === 'update/afteredit'){
        return {};
    }else{
        return state;
    }
}


